import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGaurd } from "./auth/auth-gaurd.service";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./auth/login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
    canLoad: [AuthGaurd],
  },
  {
    path: "users",
    loadChildren: () =>
      import("./users/users.module").then((m) => m.UsersPageModule),
    canLoad: [AuthGaurd],
  },
  {
    path: "laws",
    loadChildren: () =>
      import("./laws/laws.module").then((m) => m.LawsPageModule),
    canLoad: [AuthGaurd],
  },
  {
    path: "liqudations",
    loadChildren: () =>
      import("./liqudations/liqudations.module").then(
        (m) => m.LiqudationsPageModule
      ),
    canLoad: [AuthGaurd],
  },
  {
    path: "discussions",
    loadChildren: () =>
      import("./discussions/discussions.module").then(
        (m) => m.DiscussionsPageModule
      ),
    canLoad: [AuthGaurd],
  },
  {
    path: "stats",
    loadChildren: () =>
      import("./stats/stats.module").then((m) => m.StatsPageModule),
    canLoad: [AuthGaurd],
  },
  {
    path: "terms",
    loadChildren: () =>
      import("./terms/terms.module").then((m) => m.TermsPageModule),
    canLoad: [AuthGaurd],
  },
  {
    path: "subscription",
    canLoad: [AuthGaurd],
    loadChildren: () =>
      import("./subscription/subscription.module").then(
        (m) => m.SubscriptionPageModule
      ),
  },
  {
    path: "books",
    loadChildren: () =>
      import("./book/book.module").then((m) => m.BookPageModule),
    canLoad: [AuthGaurd],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
